import React from 'react';
import { Flex, Icon, Text } from 'pounceV2';
import { ModalInputProps } from 'Components/fields/ModalInput/ModalInputV3';
import { toPlural } from 'Helpers/utils';
import { useTheme } from '@mui/material';

export type ModalInputTriggerProps<T> = Pick<
  ModalInputProps<T>,
  'value' | 'invalid' | 'disabled' | 'label'
>;

function ModalInputTriggerV3<T>(
  props: ModalInputTriggerProps<T>,
): React.ReactElement<ModalInputTriggerProps<T>> {
  const {
    palette: { tokens },
  } = useTheme();
  const { value, invalid: isInvalid } = props;
  const items = value as T[];

  return (
    <Flex
      align="center"
      justify="space-between"
      color={isInvalid ? tokens.content.text.semantic.error.base : tokens.content.text.neutral.base}
      height="100%"
      px={2}
      py={1}
      gap={2}
    >
      <Text variant="body/sm" color="inherit">
        {items?.length
          ? `list (${items.length.toLocaleString()} ${toPlural('value', items.length)})`
          : '(empty list)'}
      </Text>
      {/* Negative bottom margin to center the main body of the icon.
      'watchlist' has some blank space at the bottom that throws off vertical alignment otherwise. */}
      <Icon type="watchlist" size="small" marginBottom="-1px" />
    </Flex>
  );
}

export default ModalInputTriggerV3;
